import React, { useContext } from 'react'
import { Flex } from 'antd'
import { t } from 'i18next'
import SpecialistCalendar from '../Common/SpecialistCalendar'
import SpecialistSlots from '../Common/SpecialistSlot'
import SpecialistContext from '../SpecialistContext'
import { Color } from '../../../Common/Color'
import SpecialistReason from '../Common/SpecialistReason'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function ComputerSpecialist ({ selectSpecialist, selectReason, dateCellRender, headerRender, onSelect, displaySlots }) {
  const { reason, reasons } = useContext(SpecialistContext)
  const screens = useBreakpoint()

  const displaySpecialists = (xl) => {
    if (xl) {
      return (
        <div style={{ width: '100%', padding: '3em 0', backgroundColor: Color.grey }}>
          <Flex justify='space-around'>
            <SpecialistReason selectSpecialist={selectSpecialist} selectReason={selectReason} width={'22vw'} />
            <SpecialistCalendar dateCellRender={dateCellRender} headerRender={headerRender} onSelect={onSelect} width={'22vw'} />
            <SpecialistSlots displaySlots={displaySlots} width={'22vw'} />
          </Flex>
        </div>
      )
    } else {
      return (
        <div style={{ margin: 'auto', maxWidth: '430px' }}>
          <Flex vertical align='center' style={{ backgroundColor: Color.white }}>
            <SpecialistReason selectSpecialist={selectSpecialist} selectReason={selectReason} />
            <SpecialistCalendar dateCellRender={dateCellRender} headerRender={headerRender} onSelect={onSelect} />
            <SpecialistSlots displaySlots={displaySlots} />
          </Flex>
        </div>
      )
    }
  }

  return (
    <>
      { reason && displaySpecialists(screens.xl) }
      { reasons?.length === 0 &&
        <div style={{
          boxShadow: '0px 0px 2px 2px #f2f2f2',
          borderRadius: '1em',
          padding: '1em',
          margin: '1em',
          maxWidth: '290px',
          fontSize: '1.2em',
          textAlign: 'center'
        }}>
          <div style={{ color: Color.green, fontWeight: 'bold' }}>
            {t('Public.Specialist.empty')}
          </div>
        </div>
      }
    </>
  )
}
